import { cn } from "@/lib/utils";

export type FunnelKey = "tofu" | "mofu" | "bofu";

export type FunnelMix = {
  pct?: Partial<Record<FunnelKey, number>>;
  target?: Partial<Record<FunnelKey, number>>;
  warning?: string;
};

const KEYS: FunnelKey[] = ["tofu", "mofu", "bofu"];

export default function FunnelMixBars({
  mix,
  className,
  themeLine,
}: {
  mix: FunnelMix;
  className?: string;
  themeLine?: string;
}) {
  const pct = mix.pct || {};
  const target = mix.target || { tofu: 40, mofu: 40, bofu: 20 };

  return (
    <div className={cn("space-y-3", className)}>
      {themeLine ? <p className="text-xs text-muted-foreground">{themeLine}</p> : null}
      {mix.warning ? (
        <p className="text-xs text-amber-700">{mix.warning}</p>
      ) : null}
      <div className="grid gap-3 sm:grid-cols-3">
        {KEYS.map((key) => (
          <div key={key}>
            <div className="mb-1 flex justify-between text-xs uppercase text-muted-foreground">
              <span>{key}</span>
              <span>
                {pct[key] || 0}% / {target[key] ?? 0}%
              </span>
            </div>
            <div className="h-2 overflow-hidden rounded bg-muted">
              <div
                className="h-full bg-brand"
                style={{ width: `${Math.min(100, Number(pct[key] || 0))}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
